<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ (data?.id?'title.update-record':'title.new-record') | translate}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">

  </button>
</div>

<div class="modal-body">
  <!-- Güncelleme  -->
  <div>
    <form #createForm="ngForm" class="needs-validation" novalidate>
      <div class="card">
        <div class="card-body">
          <!-- Ad-->
          <div class="form-group">
            <label class="custom-form-label" for="cardNumber">{{'customer.cardNumber' | translate}}</label>
            <input #cardNumber="ngModel" type="text" class="form-control" name="cardNumber" [(ngModel)]="data.cardNumber" appUppercase required
              [class.is-invalid]="cardNumber.invalid && cardNumber.touched" ngbAutoFocus [disabled]="disableCardNumber" />
            <app-field-error-display [displayError]="cardNumber.invalid && cardNumber.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
            </app-field-error-display>
          </div>

          <!-- Kart tipi -->
          <div class="form-group">
            <label class="custom-form-label" for="cardType">{{'loyalty.cardType' | translate}}</label>
            <select #cardType name="cardType" class="form-control input-lg" [(ngModel)]="data.cardTypeId" required>
              <option *ngFor="let item of loyaltyCardTypes" [ngValue]="item.id">{{ item.name }}
              </option>
            </select>

            <app-field-error-display class="col-sm-12" [displayError]="cardType.invalid && cardType.touched" errorMsg="Please inform your posDevice">
            </app-field-error-display>
          </div>
          <div class="row form-group">
            <div class="col-sm-12">
              <label class="custom-form-label">{{'common.firstActivationDate' | translate}}</label>
            </div>
            <div class="col-sm-12 form-group">
              <p-calendar name="firstActivationDate" [(ngModel)]="data.firstActivationDate" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                [dateFormat]="dateFormatEnum.DATE_TIME_PICKER_INPUT_FORMAT" [showTime]="true" [firstDayOfWeek]="'firstDayOfWeek'| translate">
              </p-calendar>
            </div>
          </div>
          <!-- startDate -->
          <div class="row form-group">
            <div class="col-sm-12">
              <label class="custom-form-label">{{'common.startDate' | translate}}</label>
            </div>
            <div class="col-sm-12">
              <p-calendar name="startDate" [(ngModel)]="data.startDate" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [dateFormat]="dateFormatEnum.DATE_TIME_PICKER_INPUT_FORMAT"
                [showTime]="true" [firstDayOfWeek]="'firstDayOfWeek'| translate">
              </p-calendar>
            </div>
          </div>
          <!-- endDate -->
          <div class="row form-group">
            <div class="col-sm-12">
              <label class="custom-form-label">{{'common.endDate' | translate}}</label>
            </div>
            <div class="col-sm-12">
              <p-calendar name="endDate" [(ngModel)]="data.endDate" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [dateFormat]="dateFormatEnum.DATE_TIME_PICKER_INPUT_FORMAT"
                [showTime]="true" [firstDayOfWeek]="'firstDayOfWeek'| translate">
              </p-calendar>
            </div>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">
    {{'button.close' | translate}}
  </button>

  <button type="button" [disabled]="createForm.form.invalid" class="btn btn-primary" (click)="save()">
    {{'button.save' | translate}}
  </button>
</div>